import { Link } from "react-router-dom";

const pageStyle = {
  minHeight: "100vh",
  background:
    "radial-gradient(1200px circle at top left, color-mix(in srgb, var(--c3) 45%, white 55%) 0%, transparent 38%), linear-gradient(180deg, #f8fcfd 0%, #ffffff 100%)",
};

const shellStyle = {
  background: "#fff",
  border: "1px solid var(--hairline)",
  borderRadius: "20px",
  padding: "2.5rem",
  boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
  width: "100%",
};

const sectionTitleStyle = {
  fontSize: "1.5rem",
  fontWeight: "700",
  color: "#1e293b",
  marginTop: "2rem",
  marginBottom: "1rem",
};

const listStyle = {
  paddingLeft: "1.5rem",
  marginBottom: "1rem",
  listStyleType: "disc",
};

export default function TermsOfService() {
  return (
    <main style={pageStyle}>
      <div
        className="container"
        style={{
          paddingTop: "2rem",
          paddingBottom: "4rem",
          paddingLeft: "clamp(1rem, 4vw, 1.5rem)",
          paddingRight: "clamp(1rem, 4vw, 1.5rem)",
          maxWidth: "800px",
          margin: "0 auto",
        }}
      >
        <header
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1rem",
            marginBottom: "2rem",
            flexWrap: "wrap",
          }}
        >
          <div>
            <div
              style={{
                fontSize: "0.85rem",
                fontWeight: 800,
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                color: "var(--ink-muted)",
              }}
            >
              BeFitFriends
            </div>
            <h1 style={{ margin: "0.25rem 0 0", fontSize: "clamp(2rem, 4vw, 3rem)" }}>
              Terms of Service
            </h1>
          </div>

          <Link
            to="/"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0.85rem 1.1rem",
              borderRadius: "999px",
              border: "1px solid var(--hairline)",
              background: "#fff",
              fontWeight: 700,
              textDecoration: "none",
              color: "inherit",
            }}
          >
            Back home
          </Link>
        </header>

        <section
          style={{
            ...shellStyle,
            padding: "clamp(1.1rem, 4vw, 2.5rem)",
          }}
        >
          <h2 style={{ fontSize: "1.75rem", fontWeight: "800", marginBottom: "0.5rem" }}>
            BeFitFriends Terms of Service Agreement
          </h2>
          <div style={{ color: "var(--ink-muted)", marginBottom: "2rem" }}>
            <strong>Effective Date:</strong> July 15, 2026
          </div>

          <h2 style={sectionTitleStyle}>1. Introduction & Acceptance</h2>
          <p>
            By creating an account or using the BeFitFriends mobile application (the "App") or services (collectively, the "Services"), you agree to be bound by these Terms of Use ("Terms") and our Privacy Policy. This is a legally binding contract between you and BeFitFriends LLC ("BeFitFriends," "we," or "us”). Please read these Terms before using the App. Once you access, use, or view the App, you are going to be legally bound by these Terms. Please also take a few moments to read our Community Guidelines, which form part of these Terms.
          </p>

          <h2 style={sectionTitleStyle}>2. Eligibility & Safety</h2>
          <p>To create an account and use BeFitFriends, you represent and warrant that:</p>
          <br />
          <ul style={listStyle}>
            <li><strong>Age:</strong> You are at least 18 years old.</li>
            <li><strong>Safety:</strong> You have never been convicted of a crime involving violence or sexual misconduct and are not a registered sex offender.</li>
            <li><strong>Authenticity:</strong> You will use your real name, real age, and current photos in your profile.</li>
            <li><strong>Conduct:</strong> You will treat other users with respect both "online" and during "offline" meetups.</li>
          </ul>

          <h3 style={sectionTitleStyle}>Child Sexual Abuse and Exploitation (CSAE)</h3>
          <p>The BeFitFriends mobile app has a zero-tolerance policy for child sexual abuse, exploitation, or harmful content. This includes content or behavior that sexually exploits, endangers, or abuses children.</p>
          <ul style={listStyle}>
            <li><strong>Reporting and In-App Feedback:</strong> Users can report child safety concerns by contacting us immediately at <strong>contact@befitfriends.com</strong></li>
            <li><strong>Action and Moderation:</strong> Upon receiving actual knowledge of Child Sexual Abuse Material (CSAM) or predatory behavior, our team will take appropriate action within 24 hours, including removing the violating content and permanently banning the associated accounts.</li>
            <li><strong>Legal Compliance:</strong> BeFitFriends complies fully with all applicable child safety laws. All confirmed instances of CSAM will be reported directly to the National Center for Missing and Exploited Children (NCMEC) and relevant law enforcement authorities.</li>
            <li><strong>Point of contact:</strong> For any child safety concerns, please contact us at <strong>contact@befitfriends.com</strong></li>
          </ul>

          <h2 style={sectionTitleStyle}>3. SAFETY & ASSUMPTION OF RISK</h2>
          <p>
            <strong>No Background Checks:</strong> While BeFitFriends aims to foster a respectful community, we do not perform identity verification or criminal background screenings on our members. You are solely responsible for your safety, and all in-person meetups or interactions are conducted at your own risk. We do not assume liability for the actions or behavior of any user, whether those interactions occur within the App or in the real world.
          </p>
          <br />
          <p>
            <strong>Physical Activity:</strong> You acknowledge that fitness activities (e.g., gym sessions, run clubs, classes) involve inherent risks of injury. You are solely responsible for your own safety and physical fitness to participate.
          </p>
          <br />
          <p>
            <strong>Offline Interactions:</strong> We are not responsible for the conduct of any user off the App. You agree to use your best judgment and follow safety precautions when meeting strangers in person.
          </p>

          <h2 style={sectionTitleStyle}>4. TYPES OF CONTENT</h2>
          <p>
            <strong>Your Content:</strong> You own the content you post, but you grant BeFitFriends a worldwide, perpetual, royalty-free license to host, use, and modify Your Content for operating and improving the App.
          </p>
          <br />
          <p>
            <strong>Member & Group Content:</strong> You may join or create public and private "Activities" or "Groups." As a group creator, you are responsible for the content posted within your group. All content must comply with our Community Guidelines & Content Standards in Section 8. We reserve the right to remove any group or content that violates our Community Guidelines.
          </p>

          <h2 style={sectionTitleStyle}>5. SUBSCRIPTIONS & AUTOMATIC RENEWALS</h2>
          <p>
            BeFitFriends may offer a premium tier with advanced filtering, account personalization, special matching features, as well as other features.
          </p>
          <br />
          <p>
            Because our App can be used without a subscription, canceling your subscription does not remove your profile from our App. If you wish to fully terminate your account, you must do so as set forth in Section 9.
          </p>
          <br />
          <p>
            <strong>Auto-Renewal:</strong> If you purchase a subscription, it will automatically renew at the end of each period at the then-current price until you cancel.
          </p>
          <br />
          <p>
            <strong>Cancellation:</strong> To avoid new charges, you must cancel before the end of your current period. Deleting the App does not cancel your subscription.
          </p>
          <br />
          <p>
            <strong>Free Trials:</strong> If you enroll in a free trial and do not terminate it, the trial will automatically transition into a paid subscription, with your chosen payment method being billed at the current rate. This paid subscription will continue to renew automatically and incur charges at the end of each billing cycle unless you proactively cancel. To prevent being billed for a new period, you must complete the cancellation process before your current trial or subscription term expires. Please note that neither deleting the BeFitFriends application nor closing your account will stop a free trial or recurring charges. Additionally, if you have previously utilized a free trial through the Apple App Store or Google Play Store, you will not be eligible for a second trial and will be immediately enrolled in a paid subscription upon signup.
          </p>

          <h2 style={sectionTitleStyle}>6. REFUNDS & STATE-SPECIFIC RIGHTS</h2>
          <p>
            <strong>General Policy:</strong> Generally, all charges for In-App Purchases are nonrefundable and there are no refunds or credits for partially used periods.
          </p>
          <br />
          <p>However:</p>
          <br />
          <p>For subscribers who reside in Arizona, California, Colorado, Connecticut, Illinois, Iowa, Minnesota, New York, North Carolina, Ohio, Rhode Island, and Wisconsin, the terms below apply:</p>
          <br />
          <ul style={listStyle}>
            <li><strong>Right to Cancel:</strong> You have the right to terminate your subscription for a full refund without any further obligation if you do so by midnight of the third business day after their initial purchase, excluding Sundays and holidays. If you subscribed using an Apple ID, all refund requests and payment processing are managed exclusively by Apple Support. If your subscription was started through the Google Play Store or directly within the BeFitFriends App, you must contact BeFitFriends customer support to initiate the refund process.</li>
           <br />
            <li><strong>Refund Upon Death:</strong> If your death occurs prior to the conclusion of your subscription term, your estate has the right to receive a pro-rated refund for the part of your payment that applies to the time remaining after your passing.</li>
           <br />
            <li><strong>Refund Upon Disability:</strong> If you experience a disability that prevents you from using the App before your subscription term expires, you are eligible for a pro-rated refund covering the remaining portion of your paid period. To receive this refund, you must submit a formal request to BeFitFriends LLC following the same procedures required for a standard refund.</li>
          </ul>
          <h2 style={sectionTitleStyle}>7. PROHIBITED CONDUCT</h2>
          <p>You agree not to:</p>
          <ul style={listStyle}>
            <li>Use BeFitFriends for commercial solicitation, such as selling personal training or supplements, without our permission.</li>
            <li>Submit false or malicious reports against other members.</li>
            <li>Scrape data or use automated bots to access the Services.</li>
            <li>Deceive other members by actively creating or using a fake profile, in which you are using a name or likeness that is not your own.</li>
          </ul>
          <h2 style={sectionTitleStyle}>8. COMMUNITY GUIDELINES & CONTENT STANDARDS</h2>
          <p>
            BeFitFriends is committed to a safe and supportive fitness environment. These standards apply to all users across the United States. In addition to the above terms, we impose strict restrictions on content and behavior. You agree not to post, upload, or share any content that:
          </p>
          <br />
          <ul style={listStyle}>
            <li><strong>Criminal Activity:</strong> Do not use the App to promote, facilitate, or engage in any acts that violate local, state, or federal laws.</li>
            <li><strong>Harassment & Bullying:</strong> We prohibit content intended to stalk, intimidate, or defame others. This includes any behavior that creates a hostile environment for our fitness community.</li>
            <li><strong>Privacy Violations:</strong> Respect the privacy of others. You may not post photos, videos, or private information of another person without their clear permission. Additionally, you are prohibited from posting any content that belongs to another person, company, or entity that is protected by copyright, trademark, or other intellectual property laws.</li>
          <li><strong>Safety of Minors:</strong> Any content or behavior within the App that endangers minors or involves the exploitation of children is strictly prohibited and will be reported to law enforcement and the National Center for Missing and Exploited Children (NCMEC).</li>
            <li><strong>Explicit Material:</strong> BeFitFriends is a fitness-focused social space. Do not post sexually explicit, pornographic, or gratuitously violent content.</li>
            <li><strong>Hate Speech:</strong> We have zero tolerance for content that promotes discrimination, violence, or hatred based on race, gender, religion, sexual orientation, or disability.</li>
            <li><strong>Unauthorized Commerce:</strong> Unless approved by us in writing, do not use the App for commercial gain, including selling personal training, supplements, or gym memberships.</li>
            <li><strong>Software Integrity:</strong> You may not upload code or files intended to disrupt the App’s performance or compromise the security of our users' devices.</li>
            <li><strong>Fraud & Impersonation:</strong> Profiles must be authentic. Do not impersonate others or use the App to conduct scams or fraudulent activities.</li>
          </ul>

          <h2 style={sectionTitleStyle}>9. TERMINATION</h2>
          <p>
            We may suspend or terminate your account at our sole discretion if we believe you have violated these Terms or behaved inappropriately, on or off the platform. In the event of termination for cause, you will not receive a refund for any paid features.
          </p>

          <h2 style={sectionTitleStyle}>10. LIMITATION OF LIABILITY</h2>
          <p>
            To the fullest extent permitted by law, BeFitFriends LLC and its affiliates will not be liable for any indirect, incidental, or consequential damages arising from your use of the Services or interactions with other users. In no event shall our total liability exceed $100.00.
          </p>

          <h2 style={sectionTitleStyle}>11. DISPUTE RESOLUTION (FLORIDA)</h2>
          <ul style={listStyle}>
            <li><strong>Informal Resolution:</strong> Before filing a claim, you agree to notify BeFitFriends at our Florida office and attempt to resolve the dispute informally for 60 days.</li>
            <li><strong>Binding Arbitration:</strong> Any unresolved disputes shall be exclusively settled by binding individual arbitration.</li>
            <li><strong>Class Action Waiver:</strong> You and BeFitFriends waive the right to bring any dispute as a class, collective, or representative action.</li>
            <li><strong>Governing Law:</strong> These Terms are governed by the laws of the State of Florida.</li>
          </ul>

          <h2 style={sectionTitleStyle}>12. COPYRIGHT POLICY (DMCA)</h2>
          <p>
            If you believe that any content available on BeFitFriends infringes upon a copyright you own or control, you may submit a formal "DMCA Takedown Notice" to our designated agent. To be effective, your notice must be in writing and include the following information:
          </p>
          <ul style={listStyle}>
            <br />
            <li><strong>Signature:</strong> A physical or electronic signature of the person authorized to act on behalf of the copyright owner.</li>
            <li><strong>Identification of Work:</strong> A clear description of the copyrighted work you claim has been infringed.</li>
            <li><strong>Location of Infringement:</strong> The URL or specific location within the App where the allegedly infringing material is located, with enough detail for us to find it.</li>
            <li><strong>Contact Information:</strong> Your name, mailing address, telephone number, and email address.</li>
            <li><strong>Good Faith Statement:</strong> A statement that you have a good faith belief that the use of the material is not authorized by the copyright owner, its agent, or the law.</li>
            <li><strong>Accuracy Statement:</strong> A statement, made under penalty of perjury, that the information in your notice is accurate and that you are authorized to act on behalf of the owner.</li>
          </ul>
          <p><strong>Designated Agent Contact:</strong></p>
          <p>Please send all Takedown Notices to:</p>
          <address style={{ fontStyle: "normal", paddingLeft: "1.5rem", borderLeft: "2px solid var(--hairline)", margin: "1rem 0" }}>
            BeFitFriends LLC<br />
            Attn: Copyright Agent Matthew Heano<br />
            <a href="mailto:copyright@befitfriends.com">copyright@befitfriends.com</a>
          </address>
          <p>
            <strong>Note on Repeat Infringers:</strong> In accordance with the DMCA and other applicable laws, BeFitFriends maintains a policy of terminating, in appropriate circumstances, the accounts of users who are deemed to be repeat infringers. We may also, at our sole discretion, limit access to the Services or terminate the accounts of any users who infringe the intellectual property rights of others, whether or not there is any repeat infringement.
          </p>
        </section>
      </div>
    </main>
  );
}